<div class="main-farm">
    <div class="farm-title-description">
        <h4 class="mb-4">Edit Farm Information</h4>
    </div>
    <div class="main-farm-group edit-farm">
        <form *ngIf="farmForm" [formGroup]="farmForm" (ngSubmit)="onSubmit()">
            <div class="farm-add-group">
                <div class="accordion-edit">
                    <!-- Farm Basic Information -->
                    <div class="farm-top-group">
                        <!-- First Row: Name and Address -->
                        <div class="farm-form-row">
                            <div class="input-group-farm">
                                <label
                                    >Name:<span class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="name"
                                    type="text"
                                    placeholder="Enter farm name"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('name')?.invalid &&
                                            farmForm.get('name')?.touched
                                    }"
                                />
                                <div
                                    *ngIf="
                                        farmForm.get('name')?.invalid &&
                                        farmForm.get('name')?.touched
                                    "
                                    class="invalid-feedback"
                                >
                                    Farm name is required.
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    >Address:<span class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="address"
                                    type="text"
                                    placeholder="Enter farm address"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('address')?.invalid &&
                                            farmForm.get('address')?.touched
                                    }"
                                />
                                <div
                                    *ngIf="
                                        farmForm.get('address')?.invalid &&
                                        farmForm.get('address')?.touched
                                    "
                                    class="invalid-feedback"
                                >
                                    Farm address is required.
                                </div>
                            </div>
                        </div>

                        <!-- Second Row: Bird Type, Breed, and Measurements -->
                        <div class="farm-form-row">
                            <div class="input-group-farm">
                                <label
                                    >Bird Type:<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <select
                                    formControlName="type"
                                    id="type"
                                    class="input-field"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('type')?.invalid &&
                                            farmForm.get('type')?.touched
                                    }"
                                >
                                    <option value="0" disabled selected>
                                        Select Bird Type
                                    </option>
                                    <option
                                        *ngFor="let bird of birdTypes"
                                        [value]="bird.id"
                                    >
                                        {{ bird.name }}
                                    </option>
                                </select>
                                <div
                                    *ngIf="
                                        farmForm.get('type')?.invalid &&
                                        farmForm.get('type')?.touched
                                    "
                                    class="invalid-feedback"
                                >
                                    Please select a bird type.
                                </div>
                            </div>

                            <!-- BREED FIELD - COMMENTED OUT - TO BE ADDED LATER -->
                            <!-- <div class="input-group-farm">
                                <label
                                    >Breed:<span class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <select
                                    formControlName="breedId"
                                    id="breed"
                                    class="input-field"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('breedId')?.invalid &&
                                            farmForm.get('breedId')?.touched
                                    }"
                                >
                                    <option value="0" disabled selected>
                                        Select Breed
                                    </option>
                                    <option
                                        *ngFor="let breed of breeds"
                                        [value]="breed.id"
                                    >
                                        {{ breed.name }}
                                    </option>
                                </select>
                                <div
                                    *ngIf="
                                        farmForm.get('breedId')?.invalid &&
                                        farmForm.get('breedId')?.touched
                                    "
                                    class="invalid-feedback"
                                >
                                    Please select a breed.
                                </div>
                            </div> -->

                            <div class="input-group-farm">
                                <label
                                    >Farm Length (m):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="length"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('length')?.invalid &&
                                            farmForm.get('length')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('length')?.invalid &&
                                        farmForm.get('length')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('length')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        >Farm length is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('length')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        >Length must be greater than 0.</span
                                    >
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    >Farm Width (m):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="width"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('width')?.invalid &&
                                            farmForm.get('width')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('width')?.invalid &&
                                        farmForm.get('width')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        >Farm width is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        >Width must be greater than 0.</span
                                    >
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    >Farm Size (m²):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field readonly-field"
                                    formControlName="size"
                                    type="number"
                                    readonly
                                    disabled
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('size')?.invalid &&
                                            farmForm.get('size')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="farmForm.get('size')?.invalid"
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('size')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        >Farm size is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('size')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        >Size must be greater than 0.</span
                                    >
                                </div>
                            </div>

                             <div class="input-group-farm">
                                <label
                                    >Water Tank Capacity (l):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="waterTank"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('waterTank')?.invalid &&
                                            farmForm.get('waterTank')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('waterTank')?.invalid &&
                                        farmForm.get('waterTank')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('waterTank')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        >Water Tank is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        >Width must be greater than 0.</span
                                    >
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    >Diesel Tank Capacity (l):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="dieselTank"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('dieselTank')?.invalid &&
                                            farmForm.get('dieselTank')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('dieselTank')?.invalid &&
                                        farmForm.get('dieselTank')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('dieselTank')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        > Diesel Tank is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        >Diesel Tank must be greater than 0.</span
                                    >
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    > Water Tank Height (mm):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="waterTankHeight"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('waterTankHeight')?.invalid &&
                                            farmForm.get('waterTankHeight')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('waterTankHeight')?.invalid &&
                                        farmForm.get('waterTankHeight')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('waterTankHeight')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        > Water Tank Height is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        > Water Tank Height must be greater than 0.</span
                                    >
                                </div>
                            </div>

                            <div class="input-group-farm">
                                <label
                                    > Diesel Tank Height (mm):<span
                                        class="text-danger-required"
                                        >*</span
                                    ></label
                                >
                                <input
                                    class="input-field"
                                    formControlName="dieselTankHeight"
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    placeholder="0.00"
                                    [ngClass]="{
                                        'is-invalid':
                                            farmForm.get('dieselTankHeight')?.invalid &&
                                            farmForm.get('dieselTankHeight')?.touched
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    *ngIf="
                                        farmForm.get('dieselTankHeight')?.invalid &&
                                        farmForm.get('dieselTankHeight')?.touched
                                    "
                                >
                                    <span
                                        *ngIf="
                                            farmForm.get('dieselTankHeight')?.errors?.[
                                                'required'
                                            ]
                                        "
                                        > Diesel Tank Height is required.</span
                                    >
                                    <span
                                        *ngIf="
                                            farmForm.get('width')?.errors?.[
                                                'min'
                                            ]
                                        "
                                        > Diesel Tank Height must be greater than 0.</span
                                    >
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Farmhouses Section -->
                    <div
                        formArrayName="farmHouses"
                        class="farm-farm-house-group"
                    >
                        <div
                            class="farmhouse"
                            *ngFor="
                                let house of farmHouses.controls;
                                let i = index
                            "
                            [formGroupName]="i"
                        >
                            <ng-container
                                *ngIf="
                                    !(
                                        i === 0 &&
                                        house
                                            .get('name')
                                            ?.value?.toLowerCase() === 'house 0'
                                    )
                                "
                            >
                                <div class="farmhouse-header-row">
                                    <div class="accordion-header">
                                        <h3>{{ house.get('name')?.value }}</h3>
                                    </div>
                                    <button
                                        class="btn btn-remove-farmhouse"
                                        type="button"
                                        (click)="removeFarmHouse(i)"
                                        title="Remove this farmhouse"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                                <div class="accordion-body show">
                                    <div class="farmhouse-form-row">
                                        <div class="input-group-farm">
                                            <label
                                                >Name:<span
                                                    class="text-danger-required"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input-field"
                                                formControlName="name"
                                                type="text"
                                                placeholder="Enter farmhouse name"
                                                [ngClass]="{
                                                    'is-invalid':
                                                        house.get('name')
                                                            ?.invalid &&
                                                        house.get('name')
                                                            ?.touched
                                                }"
                                            />

                                            <div
                                                *ngIf="
                                                    house.get('name')
                                                        ?.invalid &&
                                                    house.get('name')?.touched
                                                "
                                                class="invalid-feedback"
                                            >
                                                <span
                                                    *ngIf="
                                                        house.get('name')
                                                            ?.errors?.required
                                                    "
                                                    >Farmhouse name is
                                                    required.</span
                                                >
                                                <span
                                                    *ngIf="
                                                        house.get('name')
                                                            ?.errors
                                                            ?.reservedName
                                                    "
                                                    >Cannot use reserved house
                                                    names: '0' or 'House
                                                    0'.</span
                                                >
                                            </div>
                                        </div>
                                        <div class="input-group-farm">
                                            <label
                                                >Length (m):<span
                                                    class="text-danger-required"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input-field"
                                                formControlName="length"
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="0.00"
                                                [ngClass]="{
                                                    'is-invalid':
                                                        house.get('length')
                                                            ?.invalid &&
                                                        house.get('length')
                                                            ?.touched
                                                }"
                                            />

                                            <div
                                                *ngIf="
                                                    house.get('length')
                                                        ?.invalid &&
                                                    house.get('length')?.touched
                                                "
                                                class="invalid-feedback"
                                            >
                                                Length is required and must be
                                                greater than 0.
                                            </div>
                                        </div>
                                        <div class="input-group-farm">
                                            <label
                                                >Width (m):<span
                                                    class="text-danger-required"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input-field"
                                                formControlName="width"
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="0.00"
                                                [ngClass]="{
                                                    'is-invalid':
                                                        house.get('width')
                                                            ?.invalid &&
                                                        house.get('width')
                                                            ?.touched
                                                }"
                                            />

                                            <div
                                                *ngIf="
                                                    house.get('width')
                                                        ?.invalid &&
                                                    house.get('width')?.touched
                                                "
                                                class="invalid-feedback"
                                            >
                                                Width is required and must be
                                                greater than 0.
                                            </div>
                                        </div>
                                        <div class="input-group-farm">
                                            <label
                                                >feeding Silo Capacity:<span
                                                    class="text-danger-required"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input-field"
                                                formControlName="feedingSiloCapacity"
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="0.00"
                                                [ngClass]="{
                                                    'is-invalid':
                                                        house.get('feedingSiloCapacity')
                                                            ?.invalid &&
                                                        house.get('feedingSiloCapacity')
                                                            ?.touched
                                                }"
                                            />

                                            <div
                                                *ngIf="
                                                    house.get('feedingSiloCapacity')
                                                        ?.invalid &&
                                                    house.get('feedingSiloCapacity')?.touched
                                                "
                                                class="invalid-feedback"
                                            >
                                                Feeding Silo Capacity is required and must be
                                                greater than 0.
                                            </div>
                                        </div>
                                        <div class="input-group-farm">
                                            <label
                                                >feeding Silo Height:<span
                                                    class="text-danger-required"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                class="input-field"
                                                formControlName="feedingSiloHeight"
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                placeholder="0.00"
                                                [ngClass]="{
                                                    'is-invalid':
                                                        house.get('feedingSiloHeight')
                                                            ?.invalid &&
                                                        house.get('feedingSiloHeight')
                                                            ?.touched
                                                }"
                                            />

                                            <div
                                                *ngIf="
                                                    house.get('feedingSiloHeight')
                                                        ?.invalid &&
                                                    house.get('feedingSiloHeight')?.touched
                                                "
                                                class="invalid-feedback"
                                            >
                                                Feeding Silo Height is required and must be
                                                greater than 0.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Partitions Section -->
                                    <div formArrayName="farmHousePartitions">
                                        <div
                                            class="partition"
                                            *ngFor="
                                                let partition of getPartitions(
                                                    i
                                                ).controls;
                                                let j = index
                                            "
                                            [formGroupName]="j"
                                        >
                                            <div class="partition-header">
                                                <h4>Partition {{ j + 1 }}</h4>
                                                <button
                                                    class="btn btn-remove-partition"
                                                    type="button"
                                                    (click)="
                                                        removePartition(i, j)
                                                    "
                                                    title="Remove this partition"
                                                >
                                                    <i
                                                        class="fas fa-trash-alt"
                                                    ></i>
                                                </button>
                                            </div>
                                            <div class="partition-form-row">
                                                <div class="input-group-farm">
                                                    <label
                                                        >Partition Name:<span
                                                            class="text-danger-required"
                                                            >*</span
                                                        ></label
                                                    >
                                                    <input
                                                        class="input-field"
                                                        formControlName="name"
                                                        type="text"
                                                        placeholder="Enter partition name"
                                                        [ngClass]="{
                                                            'is-invalid':
                                                                partition.get(
                                                                    'name'
                                                                )?.invalid &&
                                                                partition.get(
                                                                    'name'
                                                                )?.touched
                                                        }"
                                                    />

                                                    <div
                                                        *ngIf="
                                                            partition.get(
                                                                'name'
                                                            )?.invalid &&
                                                            partition.get(
                                                                'name'
                                                            )?.touched
                                                        "
                                                        class="invalid-feedback"
                                                    >
                                                        Partition name is
                                                        required.
                                                    </div>
                                                </div>
                                                <div class="input-group-farm">
                                                    <label
                                                        >Length (m):<span
                                                            class="text-danger-required"
                                                            >*</span
                                                        ></label
                                                    >
                                                    <input
                                                        class="input-field"
                                                        formControlName="length"
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        placeholder="0.00"
                                                        [ngClass]="{
                                                            'is-invalid':
                                                                partition.get(
                                                                    'length'
                                                                )?.invalid &&
                                                                partition.get(
                                                                    'length'
                                                                )?.touched
                                                        }"
                                                    />

                                                    <div
                                                        *ngIf="
                                                            partition.get(
                                                                'length'
                                                            )?.invalid &&
                                                            partition.get(
                                                                'length'
                                                            )?.touched
                                                        "
                                                        class="invalid-feedback"
                                                    >
                                                        Length is required and
                                                        must be greater than 0.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="partition-form-row">
                                                <!-- SENSORS - HIDE UI
                                            <div
                                                class="input-group-farm sensor-selection"
                                            >
                                                <label>Select Sensors:</label>
                                                <p-multiSelect
                                                    [options]="availableSensors"
                                                    formControlName="sensors"
                                                    optionLabel="name"
                                                    optionValue="id"
                                                    appendTo="body"
                                                    class="custom-multiselect"
                                                    defaultLabel="Select sensors for this partition"
                                                    placeholder="Choose sensors..."
                                                    [filter]="true"
                                                    filterPlaceHolder="Search sensors..."
                                                    [showToggleAll]="true"
                                                    [showHeader]="true"
                                                    [displaySelectedLabel]="
                                                        true
                                                    "
                                                    [maxSelectedLabels]="3"
                                                    selectedItemsLabel="{0} sensors selected"
                                                >
                                                </p-multiSelect>
                                            </div>
                                            -->
                                                <div class="input-group-farm">
                                                    <label
                                                        >Capacity (per
                                                        chick):<span
                                                            class="text-danger-required"
                                                            >*</span
                                                        ></label
                                                    >
                                                    <input
                                                        class="input-field"
                                                        formControlName="capacity"
                                                        type="number"
                                                        min="0"
                                                        placeholder="0"
                                                        [ngClass]="{
                                                            'is-invalid':
                                                                partition.get(
                                                                    'capacity'
                                                                )?.invalid &&
                                                                partition.get(
                                                                    'capacity'
                                                                )?.touched
                                                        }"
                                                    />

                                                    <div
                                                        *ngIf="
                                                            partition.get(
                                                                'capacity'
                                                            )?.invalid &&
                                                            partition.get(
                                                                'capacity'
                                                            )?.touched
                                                        "
                                                        class="invalid-feedback"
                                                    >
                                                        Capacity is required and
                                                        must be greater than 0.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        class="btn btn-action-secondary"
                                        (click)="addPartition(i)"
                                    >
                                        <i class="fas fa-plus"></i> Add
                                        Partition
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <button
                    type="button"
                    class="btn btn-action-secondary"
                    (click)="addFarmHouse()"
                >
                    <i class="fas fa-plus"></i> Add Farmhouse
                </button>
            </div>
            <div class="add-farm-submit">
                <button
                    type="submit"
                    class="btn btn-primary btn-add-farm"
                    [disabled]="
                        !farmForm.valid || (isLoading$ | async) || isAuthLoading
                    "
                >
                    <span *ngIf="!isAuthLoading">Update Farm</span>
                    <span *ngIf="isAuthLoading">Updating...</span>
                </button>
                <img
                    *ngIf="isLoading$ | async"
                    src="assets/img/loader.gif"
                    alt="Loading..."
                    class="loader-image mt-2"
                />
            </div>
        </form>
    </div>
</div>
